import React from 'react';
import { NavLink } from 'react-router-dom';
import { Animated } from "react-animated-css";
 
const Navbar = () => {
    return (
      <nav>
        <div><a href="#" style={{textDecoration: 'none'}}><h6 style={{color: 'MediumPurple', fontSize: 40, position: 'absolute', top: 25, left: 50}}>React Dance ⚛️</h6><img src="https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80" /></a></div>
          <NavLink style={{color: 'LightCyan', marginLeft: 400, marginRight: 42, textDecoration: 'none'}} to="/">Home</NavLink>
          <NavLink style={{color: 'MintCream', marginRight: 42, textDecoration: 'none'}} to="/dance">Dance</NavLink>
          <NavLink style={{color: 'MistyRose', marginRight: 42, textDecoration: 'none'}} to="/dance_in_pink">Dance In Pink</NavLink>
          <NavLink style={{color: 'Gainsboro', marginRight: 42, textDecoration: 'none'}} to="/dance_in_dark">Dance In Dark</NavLink>
          <NavLink style={{color: 'Snow', marginRight: 42, textDecoration: 'none'}} to="/dance_on_snow">Dance On Snow</NavLink>
          <NavLink style={{color: 'FloralWhite', marginRight: 42, textDecoration: 'none'}} to="/taste_buds_dance">Taste Buds Dance</NavLink>
          <NavLink style={{color: 'LightYellow', textDecoration: 'none'}} to="/about_us">About Us</NavLink>
      </nav>
      
    );
}
 
export default Navbar;


